import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { rejects } from 'assert';
import { isNullOrUndefined } from 'util';
import Upload from './uploadDocPolizza.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import ApplicationData from '../../app/aApplicationData'


class ProdottoPolizzzaDocument extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ProdottoPolizzzaDocument.jsx] ';
        this.state = {
            showConfirm: false,
            showConfirmDelete: false,
            prodottoDaEliminare: null
        }
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteDocumentPolizza = this.deleteDocumentPolizza.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            // { field: 'idProdottoDocument', title: i18n('ARM_CORE_PRODUCT.MANAGE.ID', 'Id'), align: "center", sortable: 'true' },
            // { field: 'name', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), align: "center", sortable: 'true' },
            { field: 'documentType', title: i18n('ARM_CORE_PRODUCT.MANAGE.DOCUMENTO', 'Documento'), align: "center", sortable: 'true', formatter: this.documentTypeFormatter },
            // { field: 'fileExtension', title: i18n('ARM_CORE_PRODUCT.MANAGE.TYPE', 'Tipo'), align: "center", sortable: 'true' },
            // { field: 'countDownload', title: i18n('ARM_CORE_PRODUCT.MANAGE.DOWNLOAD_COUNT', 'Download Count'), align: "center", sortable: 'true' },
            // { field: 'dateCre', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_CREAZIONE', 'Data Creazione'), align: "center", sortable: 'true', formatter: this.dateFormatter },
            // { field: 'idUserCre', title: i18n('ARM_CORE_PRODUCT.SHARED.CREATO_DA', 'Creato da'), align: "center", sortable: 'true' },
            { field: 'edit', title: i18n('ARM_CORE_PRODUCT.SHARED.UPLOAD_OR_DELETE', 'Carica/Elimina'), align: "center", formatter: this.columnDownload },
            // { field: 'elimina', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina"), formatter: this.columnDelete },
        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "idProdottoDocument",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.downloadOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        let rows = [{ categoria: 'Appendice' }, { categoria: 'FronteSpizio' },
        { categoria: 'Polizza' }, { categoria: 'Rinnovi' }]

        if (this.props.idProdotto) {
            this.props.getDocumentiPolizza(this.props.idProdotto).then(

                resolve => {
                    if (this.props.rows !== null && this.props.rows !== undefined) {

                        $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
                    }
                })
        }
    }

    downloadOnClick(row, $element, field) {
        console.log(this.componentName + " showConfirmPanel()");

        if (field === "documentType" && row.id) {
            this.props.downloadDocument(row.downloadLink);
        }
        if (field === "edit") {
            if (row.id) {
                this.inzializzaEliminaDocument(row.id);
            } else {
                this.setState({ docCategory: row.documentType })
                this.showConfirmPanel();
            }
        } else if (field === "elimina") {
            this.inzializzaEliminaDocument(row.id);
        }

    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    inzializzaEliminaDocument(idProdottoDocument) {

        this.setState({ prodottoDaEliminare: idProdottoDocument, showConfirmDelete: true });

    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    deleteDocumentPolizza() {

        this.showConfirmDelete();

        this.props.deleteDocumentPolizza(this.state.prodottoDaEliminare).then(

            resolve => {
                this.props.getDocumentiPolizza(this.props.idProdotto).then(

                    resolve => {
                        if (this.props.rows !== null && this.props.rows !== undefined) {

                            $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
                        }
                    })
            }
        )
    }


    documentTypeFormatter(value, row, index) {
        if (row.id) {
            return '<a style = "color: #007bff; text-decoration: underline;">' + value + '</a>'
        }
        return value;
        // return ApplicationData.domainVal('AI_DOCUMENT_CATEGORY', value, value).desDom;
    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    showConfirmPanel() {
        console.log(this.componentName + " showConfirmPanel()");

        this.setState({ showConfirm: !this.state.showConfirm })

    }

    columnDownload(value, row, index) {
        console.log("columnDownload:" + index);
        let temp;
        if (row.id === undefined) {
            temp = "<button class='btn btn-info btn-sm'><i class='fas fa-upload'></i></button>";
        } else {

            temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        }
        return temp;
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            // console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null || nextProps.rows === undefined) {
                // $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="mt-3">
            <div className="card-header">
                {/* <agui.aButton bs="primary" className="float-right" icon="fas fa-upload" onClick={this.showConfirmPanel}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')}</agui.aButton> */}
                <h3>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DOC_POLIZZA', 'Documenti di polizza')} </h3>

            </div>

                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />

                {/* {this.props.rows && this.props.rows.map(
                    (item, index) =>

                        <div key={index}>

                            <div> {index} </div>
                            <div> {item.documentType} </div>
                            <div><button class='btn btn-info btn-sm'><i class='fas fa-download'></i></button> </div>
                            <div><button class='btn btn-info btn-sm'><i class='fas fa-trash'></i></button> </div>
                        </div>
                )}

                <table className={AppConstants.CLASS_TABLE} >
                    <thead>
                        <tr>
                            <td>Index</td>
                            <td>{i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia')}</td>
                            <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PUNTO_VENDITA', 'Punto Vendita')}</td>
                            <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.QUOTA', 'Quota')}</td>
                            <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.MANDATARIA', 'Mandataria')}</td>
                            <td>{i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA', 'Elimina')}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.rows && this.props.rows.map((doc, index) =>

                            <tr key={index}>

                                <td> {index} </td>
                                <td> {doc.documentType} </td>
                                <td><button class='btn btn-info btn-sm'><i class='fas fa-download'></i></button> </td>
                                <td><button class='btn btn-info btn-sm'><i class='fas fa-trash'></i></button> </td>
                            </tr>

                        )}
                    </tbody>

                </table> */}

                <Upload idProdotto={this.props.idProdotto}
                    docCategory={this.state.docCategory}
                    show={this.state.showConfirm} close={this.showConfirmPanel}
                />
                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteDocumentPolizza}
                    onClose={this.showConfirmDelete} />
            </div>
        );
    }
};



export default ProdottoPolizzzaDocument;
